module.exports = (SalonService, RESTService) ->
  'ngInject'
  {
    service: (salonId) ->
      RESTService.service('services', SalonService.one(salonId))
  }
